<template>
    <div>
        <vue-perfect-scrollbar style="height: 408px" :settings="settings">
            <v-card
                elevation="0"
                class="clickable striped-light"
                v-for="(batch, i) in dashboard_work_orders_batches"
                :key="i"
                @click="showWorkOrdersSetting(batch)"
            >
                <v-card-title class="px-1 py-2 light-gray-hover border-bottom-1">
                    <v-layout row wrap>
                        <v-flex sm1 hidden-xs-only align-self-start pr-1>
                            <v-img
                                v-if="!$bp.xsOnly"
                                :src="batch.photo"
                                height="48px"
                                width="48px"
                                class="rounded-circle mx-auto"
                                @error="showErrorImg = true"
                            ></v-img>
                        </v-flex>
                        <v-flex xs6 column align-self-start pl-2>
                            <span class="fs-18">{{ batch.batch_control_id }}</span>
                            <span class="fs-14">{{ batch.name }}</span>
                            <span class="fs-12 pt-2">Begin setting by: {{ batch.set_date }}</span>
                            <v-img
                                v-if="$bp.xsOnly"
                                :src="batch.photo"
                                height="48px"
                                width="48px"
                                class="rounded-circle mx-auto"
                                @error="showErrorImg = true"
                            ></v-img>
                        </v-flex>
                        <v-flex xs6 sm5 align-self-start>
                            <span class="ml-auto">
                                <v-chip round disabled color="primary">
                                    <span class="white--text">{{ `${batch.batch_size} Qty` }}</span>
                                </v-chip>
                            </span>
                            <v-flex d-inline-flex>
                                <div class="d-block text-right">
                                    <div class="fs-18">{{ batch.setting_station ? batch.setting_station.people_started_by : "" }}</div>
                                    <div class="fs-12">{{ batch.setting_station ? `Started: ${batch.setting_station.date_begin}` : "" }}</div>
                                </div>
                                <v-avatar v-if="batch.setting_station" class="my-auto">
                                    <img :src="batch.setting_station.photo" />
                                </v-avatar>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-card-title>
            </v-card>
        </vue-perfect-scrollbar>
        <bc-dialog :value="work_orders_setting_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.setting") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeWorkOrdersSettingDialog"
                        :dialog-status="work_orders_setting_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="work_orders_setting" @submit.prevent>
                        <v-container grid-list-form>
                            <v-layout row wrap style="min-height: 350px">
                                <v-flex xs12 sm7 align-self-start pa-0>
                                    <v-layout row wrap inner-layout>
                                        <v-flex xs12>
                                            <span class="fs-14">{{ $t("lang.part_name") }}</span>
                                            <h3>{{ currObjField("name") }}</h3>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span class="fs-14">{{ $t("lang.customer_part_number") }}</span>
                                            <h3>{{ currObjField("customer_part_number") }}</h3>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span class="fs-14">{{ $t("lang.company") }}</span>
                                            <h3>{{ currObjField("company") }}</h3>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span class="fs-14">{{ $t("lang.control_id") }}</span>
                                            <h3>{{ currObjField("batch_control_id") }}</h3>
                                        </v-flex>
                                        <v-flex xs12 v-if="currObjField('setting_minutes_to_complete')">
                                            <span class="fs-14">{{ $t("lang.estimated_minutes_to_complete") }}</span>
                                            <h3>{{ currObjField("setting_minutes_to_complete") }}</h3>
                                        </v-flex>
                                        <v-flex xs12 sm10 v-if="currObjField('setting_station')">
                                            <v-text-field
                                                v-focus="work_orders_setting_dialog"
                                                v-model="work_orders_setting.jig_tag_number"
                                                :label="`${$t('lang.jig_tag_number')} *`"
                                                :counter="showCounter(work_orders_setting.jig_tag_number, 'work_orders_setting.jig_tag_number')"
                                                :rules="ifValid('work_orders_setting.jig_tag_number')"
                                                type="number"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm5 align-self-start pa-0>
                                    <v-img
                                        :src="currObjField('photo')"
                                        height="175px"
                                        width="175px"
                                        class="rounded-circle"
                                        :class="$bp.smAndUp ? 'mx-auto' : ''"
                                    ></v-img>
                                    <template v-if="currObjField('setting_station')">
                                        <span class="fs-18">{{ $t("lang.destination") }}</span>
                                        <span style="font-size: 100px; max-height: 90px; bottom: 30px; position: relative">{{ currObjField("furnace") }}</span>
                                    </template>
                                </v-flex>
                                <template v-if="currObjField('setting_instructions')">
                                    <v-layout row wrap inner-layout px-2 :class="$bp.xsOnly ? 'pt-3' : ''">
                                        <v-flex xs12 font-italic pb-0>{{ $t("lang.instructions") }}</v-flex>
                                        <v-flex xs12 pt-0 style="max-height: 200px; overflow-y: auto">{{ currObjField("setting_instructions") }}</v-flex>
                                    </v-layout>
                                </template>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeWorkOrdersSettingDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        color="success"
                        @mouseup.left="
                            currObjField('setting_station')
                                ? openNonconformanceAfter()
                                : modifyWorkOrdersSetting('post', currObjField('batch_id'), currSettingStationField('work_order_setting_id'))
                        "
                        >{{ currObjField("setting_station") ? $t("lang.complete") : $t("lang.yes") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="confirm_nonconformance_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.final_check") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="confirm_nonconformance_dialog"
                        :dialog-status="confirm_nonconformance_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <span class="fs-22">Do you need to report a nonconformance for this batch?</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="modifyWorkOrdersSetting('patch', currObjField('batch_id'), currSettingStationField('work_order_setting_id'))">{{
                        $t("lang.no")
                    }}</v-btn>
                    <v-btn
                        color="success"
                        @mouseup.left="modifyWorkOrdersSetting('patch', currObjField('batch_id'), currSettingStationField('work_order_setting_id'), true)"
                    >
                        {{ $t("lang.yes") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>
<script>
import api from "Api";
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {
            work_orders_setting_dialog: false,
            confirm_nonconformance_dialog: false,
            work_orders_setting: {
                batch_id: "",
                jig_tag_number: "",
            },
            current_obj: null,
            loader: true,
            settings: {
                maxScrollbarLength: 160,
            },
            headers: [
                {
                    text: this.$t("lang.type"),
                    value: "type",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.qty"),
                    value: "nonconformance_qty",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.description"),
                    value: "description",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.reason_code_id"),
                    value: "reason_code_id",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.created_by"),
                    value: "created_by",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
            ],
        };
    },
    mounted() {
        if (this.dashboard_work_orders_batches == null) this.getWorkOrdersSettings();
    },
    computed: {
        ...mapState({
            rules_work_orders_setting: (state) => state.validation.rules_work_orders_setting,
            dashboard_work_orders_batches: (state) => state.work_orders.dashboard_work_orders_batches,
        }),
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        currSettingStationField() {
            return (field) => {
                return this.current_obj && this.current_obj.setting_station && field && this.current_obj.setting_station[field]
                    ? this.current_obj.setting_station[field]
                    : "";
            };
        },
    },
    methods: {
        getWorkOrdersSettings(refresh = false) {
            if (refresh) {
                this.$store.commit("commitWorkOrder", {
                    property: "dashboard_work_orders_batches",
                    with: null,
                });
            }

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "work_orders/continuous/setting",
                    method: "get",
                    stateProperty: "dashboard_work_orders_batches",
                    dataProperty: "work_orders_batches",
                    commit: true,
                })
                .then(() => {});
        },
        closeWorkOrdersSettingDialog() {
            this.work_orders_setting_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        modifyWorkOrdersSetting(method = null, batch_id = null, setting_id = null, start_nonconformance = false) {
            if (method) {
                this.confirm_nonconformance_dialog = false;
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("work_orders_setting")) {
                        this.$store.commit("toggleModalLoader", true);
                        let batch_id_body = {
                            batch_id: batch_id,
                        };
                        this.$store
                            .dispatch("fetchWorkOrder", {
                                pk: "batch_id",
                                id: batch_id,
                                url: `work_orders/setting/${setting_id ? setting_id : ""}`,
                                method: method,
                                stateProperty: "dashboard_work_orders_batches",
                                dataProperty: "work_orders_batches",
                                commit: true,
                                body: method == "patch" ? this.work_orders_setting : batch_id_body,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeWorkOrdersSettingDialog();
                                    if (start_nonconformance) {
                                        this.$refs.nonconformance.showNonconformance();
                                    }
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showWorkOrdersSetting(item = null) {
            this.current_obj = item;

            if (this.$refs.work_orders_setting) item ? this.$refs.work_orders_setting.resetValidation() : this.$refs.work_orders_setting.reset();

            this.$nextTick(() => {
                this.assignObj(this.work_orders_setting, item, this.rules_work_orders_setting);
                this.work_orders_setting_dialog = true;
            });
        },
        openNonconformanceAfter() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("work_orders_setting")) {
                    this.confirm_nonconformance_dialog = true;
                }
            });
        },
    },
};
</script>
